import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";
interface MasterDnarState {
    data: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "list" | null;
}

const initialState: MasterDnarState = {
    data: null,
    loading: "idle",
    error: null,
    action: null,
};

export const getDnarList = createAsyncThunk(
    "get/dnar",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.MASTERS.DNAR_LIST, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

const masterDnarSlice = createSlice({
    name: "dnar",
    initialState,
    reducers: {
        resetMasterDnar: (state) => {
            state.loading = "idle";
            state.error = null;
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getDnarList.pending, (state) => {

            state.loading = "pending";
            state.data = null;
            state.error = null;
            state.action = "list";
        });
        builder.addCase(getDnarList.fulfilled, (state, action) => {

            state.loading = "fulfilled";
            state.data = action.payload;
            state.error = null;
            state.action = "list";
        });
        builder.addCase(getDnarList.rejected, (state, action) => {
            state.loading = "rejected";
            state.error = action.payload as string;
            state.data = null;
            state.action = "list";
        });
    },
});

export const { resetMasterDnar } = masterDnarSlice.actions;
export default masterDnarSlice.reducer;
